import Highlighter from 'react-highlight-words'

const ProviderHR = ({ hospitalRecords, handleAddHistoryToggle, getPatientHistory, AddHistoryToggle, showDataIfNoteIsFollowUp, setAddHistoryToggle, noteStructureRef, personalHistory, saveTreatsShell, patientID, loading, setHistories, setLoading, allergiesList, setAllergiesList }) => {
  const historyMapping = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role
  return (
    <div className="d-flex flex-column gap-2">
      {/* Hospital Records */}
      {/* <CAccordion >
                <CAccordionItem itemKey={1}>
                    <CAccordionHeader>Hospital Records</CAccordionHeader>
                    <CAccordionBody>
                        {hospitalRecords.filter(item => item.Id === noteStructureRef.current?.metadata?.historyId).map((record, index) => {
                            const rows = Math.max(4, Math.ceil(record.History.length / 50));
                            return (
                                <>
                                    <div
                                        contentEditable
                                        suppressContentEditableWarning={true}
                                        className="my-1"
                                        style={{ whiteSpace: 'pre-line' }}
                                    >
                                        {record.History}
                                    </div>
                                </>
                            )
                        })}

                    </CAccordionBody>
                </CAccordionItem>
            </CAccordion> */}

      {/* <span>
          <CButton
            variant="outline"
            size="sm"
            onClick={() => {
              handleAddHistoryToggle()
            }}
            style={{
              background: '#4363F2',
              color: 'white',
            }}
          >
            Add History
          </CButton>
        </span>
 */}

      {/* {!showDataIfNoteIsFollowUp && 
            <CAccordion alwaysOpen className='d-flex flex-column gap-2' >
                {Object.entries(personalHistory).map(([key, histories], index) => {
                    return (
                        <div className='d-flex flex-column gap-4' style={{background:"rgb(40, 40, 40)",padding:"20px",borderRadius:"10px"}}>
                            <b>{historyMapping[key]}</b>
                            {histories
                                    .filter(item => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]])
                                    .map((item, index) => (
                                        // {histories?.map((item, index) => (
                                        <div key={index} style={{ whiteSpace: "pre-line" }} >
                                            {item[historyObjectKeysParticular[key]]}
                                        </div>
                                    ))}
                        </div>
                        // <CAccordionItem className='border' itemKey={index}>
                        //     <CAccordionHeader>{historyMapping[key]}</CAccordionHeader>
                        //     <CAccordionBody className='d-flex flex-column gap-3'>
                        //         {histories
                        //             .filter(item => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]])
                        //             .map((item, index) => (
                        //                 // {histories?.map((item, index) => (
                        //                 <div key={index} style={{ whiteSpace: "pre-line" }} >
                        //                     {item[historyObjectKeysParticular[key]]}
                        //                 </div>
                        //             ))}
                        //     </CAccordionBody>
                        // </CAccordionItem>
                    )
                })}
            </CAccordion>
            } */}
      {hospitalRecords.filter((item) => item.Id === noteStructureRef.current?.metadata?.historyId).length > 0 && (
        <div className="" style={{ background: '#191919', padding: '20px', borderRadius: '10px' }}>
          {hospitalRecords
            .filter((item) => item.Id === noteStructureRef.current?.metadata?.historyId)
            .map((record, index) => {
              return (
                <>
                  <div className="p-0 m-0" style={{ whiteSpace: 'pre-line' }}>
                    <Highlighter textToHighlight={record.History || ''} highlightClassName="your-highlight-class" highlightStyle={{ color: 'orange', background: 'inherit' }} searchWords={noteStructureRef.current?.highlightDetails?.[record?.Id] || []} />
                  </div>
                </>
              )
            })}
        </div>
      )}
      <div>
        {hospitalRecords.filter((item) => item.Id === noteStructureRef.current?.metadata?.historyId).length === 0 && (
          <div className="d-flex justify-content-center align-items-center text-muted">
            <div
              style={{
                fontSize: '15px',
                fontWeight: '600px',
                color: 'gray',
              }}
            >
              No Hospital Records
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProviderHR
